export default __webpack_public_path__ + "settings-icon.e5d7c62a926dc775e79b3ecce8760101.svg";